import { useEffect, useState } from "react";
import AdminDashboardLayout from "../../../commonComponents/DashboardLayout";
import { IAPIResponse, IBuyer } from "../../../../common/utils/interfaces";
import { getBuyerDetails } from "../../../../../apis/admin/buyers";
import BuyersTable from "./BuyersTable";
import CustomModal from "../../../../common/components/CustomModal";
import BuyerDetails from "./BuyerDetails";

const Buyers = () => {
  const [fullDetailData, setFullDetailData] = useState<IBuyer | null>(null);
  const [detailData, setDetailData] = useState<IBuyer | null>(null);

  useEffect(() => {
    if (detailData) {
      fetchData();
    }
  }, [detailData]);

  const fetchData = async () => {
    const result: IAPIResponse | undefined = await getBuyerDetails(detailData);

    if (result) {
      const { data } = result;
      setFullDetailData(data);
    }
  };

  return (
    <AdminDashboardLayout hasHeader searchPlaceholder="Buyers">
      <>
        <div className="w-full">
          <BuyersTable setDetailData={(value) => setDetailData(value)} />
        </div>
        <CustomModal
          showModal={!!fullDetailData}
          onCloseModal={() => setFullDetailData(null)}
        >
          <BuyerDetails buyerData={fullDetailData} />
        </CustomModal>
      </>
    </AdminDashboardLayout>
  );
};

export default Buyers;
